module.exports = __webpack_public_path__ + "img/gal_12.d0666531.png";